<template>
  <acclaro-datatable
    grid-title="Invoices"
    search-route="/datatables/invoices"
    search-placeholder="Filter Invoices..."
    datatable-name="invoices"
    :search-param="options.searchParam"
    :filter-param="options.filtersParam"
    :column-templates="templates"
    >

    <template v-slot:buttons>
    </template>

    <template v-slot:aggregates="props">
      <ul>
        <li><strong>Invoices:</strong> {{ props.aggregates.total || 0}}</li>
        <li><strong>Amount:</strong> {{ strToPrice(props.aggregates.page_amount) }}</li>
      </ul>
    </template>
  </acclaro-datatable>
</template>

<script>
import Vue from 'vue';

import {
  AsEditable,
  AsLink,
  AsStatus,
  AsCell
} from '../Acclaro-Datatable/cells';

import {
  EmailIcon
} from '../icons.js';

import statusColors from '../Acclaro-Datatable/statusColors.js';

export default {

  props: {
    options: {
      type: Object,
      required: true
    }
  },

  data () {
    return {}
  },

  computed: {

    templates () {
      let $vm = this;

      return {
        'Invoice ID': function (h, row, index) {
          const props = { row, column: 'Invoice ID' };
          const invoiceId = row['Invoice ID'];

          return (
            <AsLink
              props={props}
              link={'/download?inv=1&t=' + invoiceId}
              link-text={invoiceId}
            />
          );
        },

        Amount: function (h, row, index) {
          let props = {row, column: 'Amount'};
          const {Amount, price_raw, show_order_cost, ID} = row;

          return (
            <AsCell props={props} content={Amount || '-'} />
          );
        },

        Status: function (h, row, index) {
          const props = { row, column: 'Status' };

          return (
            <AsStatus props={props}>
              <span class={'status-dots status-' + $vm.getStatusColor(row.Status)}></span>
            </AsStatus>
          );
        },

        'Order ID': function (h, row, index) {
          const props = { row, column: 'Status' };
          const { order_ids, order_keys } = row;
          let $content = (<span>-</span>);

          if (row.order_ids) {
            $content = (
              <span
                v-tooltip={order_keys.toString()}
                class="ellipsis"
                domPropsInnerHTML={row['Order ID']}></span>
            );
          }

          return (
            <AsCell props={props}>
              {$content}
            </AsCell>
          );
        },

        Share: function (h, row, index) {
          return (
            <a href="javascript:;" onClick={() => $vm.shareInvoice(row.id)}>
              <EmailIcon size={17} class="clickable"/>
            </a>
          );
        }
      }
    }
  },

  methods: {
    //legacy code for amount popup
    showAmountPopup (orderid) {
      popupPage(
        '/ajax/reports?report=price&oid=' + orderid,
        'Order ' + orderid + ': Costs',
        false,
        true
      );
    },

    getStatusColor (status) {
      return statusColors[status.toLowerCase()];
    },

    shareInvoice (orderId) {
      shareinv(orderId);
    },

    strToPrice (amount) {
      let amountFloat = parseFloat(amount);

      if (isNaN(amountFloat) || amountFloat == 0) {
        return '-';
      }

      return '$' + (this.numberWithCommas(amountFloat.toFixed(2)));
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
}
</script>
